import api from './api'

const ENDPOINT = '/admin/diagnoses'

const DiagnosesService = {
  /**
   * Get all diagnoses with pagination
   * @param {Object} params - Query params { page, per_page }
   * @returns {Promise} - Paginated list of diagnoses
   */
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  /**
   * Get single diagnosis by ID
   * @param {number} id - Diagnosis ID
   * @returns {Promise} - Diagnosis data
   */
  async getById(id) {
    const response = await api.get(`${ENDPOINT}/${id}`)
    return response.data
  },

  /**
   * Create new diagnosis
   * @param {Object} data - Diagnosis data { name, note, active }
   * @returns {Promise} - Created diagnosis
   */
  async create(data) {
    const response = await api.post(ENDPOINT, data)
    return response.data
  },

  /**
   * Update diagnosis
   * @param {number} id - Diagnosis ID
   * @param {Object} data - Diagnosis data { name, note, active }
   * @returns {Promise} - Updated diagnosis
   */
  async update(id, data) {
    const response = await api.put(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  /**
   * Delete diagnosis
   * @param {number} id - Diagnosis ID
   * @returns {Promise} - Delete response
   */
  async delete(id) {
    const response = await api.delete(`${ENDPOINT}/${id}`)
    return response.data
  },
}

export default DiagnosesService
